import styled from 'styled-components';
import { black } from 'constants/color';

export const StyledLabel = styled.p`
  color: ${black};
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 1.6rem;
`;
